import React from "react";
import { Music, Music2, Music3, Music4, AudioLines } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ArtistCommunity() {
  return <section data-section-id="224524" id="equipping-the-church" className="dark bg-card text-foreground relative w-full overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-chart-4 via-card to-background opacity-90 mix-blend-multiply dark:mix-blend-normal"></div>
      
      {}
      <div className="absolute inset-0 bg-primary/5"></div>

      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden hidden md:block">
        <Music className="absolute top-[10%] left-[5%] h-12 w-12 text-accent/20 animate-pulse" style={{
        animationDuration: '3s'
      }} />
        <Music2 className="absolute top-[20%] right-[10%] h-20 w-20 text-accent/10 transform rotate-12 animate-pulse" style={{
        animationDuration: '4s'
      }} />
        <Music3 className="absolute bottom-[15%] left-[15%] h-16 w-16 text-accent/15 transform -rotate-12 animate-pulse" style={{
        animationDuration: '5s'
      }} />
        <Music4 className="absolute bottom-[25%] right-[5%] h-10 w-10 text-accent/25 transform rotate-45 animate-pulse" style={{
        animationDuration: '2.5s'
      }} />
        <AudioLines className="absolute top-[40%] left-[50%] h-32 w-32 -translate-x-1/2 text-primary/5 opacity-20" />
      </div>

      {}
      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl lg:text-7xl mb-8 drop-shadow-sm">Grow Together in Faith</h2>
        
        <p className="font-default mx-auto mb-12 max-w-2xl text-lg text-muted-foreground sm:text-xl">Help your community grow deeper in God’s Word through biblically grounded studies focused on faith, discipleship, and lasting spiritual legacy.</p>

        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 border-none shadow-md text-base h-14 px-8 rounded-md">
            <Link to="mailto:dustin@royerheritage.com">
              Invite Dustin to Speak
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-2 border-primary bg-transparent text-primary hover:bg-primary/10 hover:text-primary shadow-md text-base h-14 px-8 rounded-md">
            <Link to="mailto:dustin@royerheritage.com">
              Bulk Order Resources
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}